export default class ContentSourceService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/content_sources/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/content_sources', params)
	}

	createEntity(params) {
		return this.apiService.callPost('me/content_sources', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/content_sources/' + id, params)
	}

	deleteEntity(id) {
		return this.apiService.callDelete('me/content_sources/' + id)
	}

	// CONTENT - CHANNELS

	updateChannelSettingsInContentSource(id, params) {
		return this.apiService.callPut('me/content_sources/' + id + '/update_channel_settings', params)
	}

	deleteChannelFromContentSource(id, params) {
		return this.apiService.callDelete('me/content_sources/' + id + '/channel', params)
	}

	// NEW CONTENT

	getNewContentFormData(id, params) {
		return this.apiService.callGet('me/content_sources/' + id + '/new_content_form_data', params)
	}

	getContentSourceChannelData(id, params) {
		return this.apiService.callGet('me/content_sources/' + id + '/content_source_channel', params)
	}

	addComplexContent(id, params) {
		return this.apiService.callPost('me/content_sources/' + id + '/add_complex_content', params)
	}

	getContentSourcesList(id){
		return this.apiService.callGet(''+id+'/content_sources/simple_list');
	}

	// SEARCH
	searchContentSourcesByNameOrId(params) {
		return this.apiService.callGet('me/content_sources/search', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ContentSourceService.js